import React, { FC, PropsWithChildren } from 'react';

const Plain: FC<PropsWithChildren> = props => <div>{props.children}</div>;

export default Plain;
